<template>
  <div justify="space-between" :style="{width: width ? width : '600px'}">
    <div class="float-left" :span="4" style="width: 100px">
      <el-select :value="provinceId" @input="handleProvinceChange" placeholder="省">
        <el-option v-for="Province in Provinces" :key="Province.ID" :label="Province.Name" :value="Province.Id"></el-option>
      </el-select>
    </div>
    <div class="float-left" :span="4" style="width: 100px; margin-left: 10px">
      <el-select :value="cityId" @input="handleCityChange" placeholder="市">
        <el-option v-for="City in Citys" :key="City.Id" :label="City.Name" :value="City.Id"></el-option>
      </el-select>
    </div>
    <div class="float-left" :span="4" style="width: 100px; margin-left: 10px">
      <el-select :value="countyId" placeholder="区县" @input="handleCountyChange">
        <el-option v-for="County in Countys" :key="County.Id" :label="County.Name" :value="County.Id"></el-option>
      </el-select>
    </div>
    <div class="float-left" :span="10" :style="{'width': '250px', 'margin-left': width ? '0px' : '10px', 'margin-top': width ? '10px' : '0px'}">
      <el-select v-if="showPoint" :value="pointId" placeholder="网点" @input="handlePointChange">
        <el-option v-for="Point in Points" :key="Point.Id" :label="Point.Name" :value="Point.Id"></el-option>
      </el-select>
      <el-input v-else :value="address" placeholder="地址" @input="handleAddressChange"></el-input>
    </div>
  </div>
</template>

<script>
import o from '@/odata'
export default {
  data() {
    return {
      Provinces: [],
      Citys: [],
      Countys: [],
      Points: [],
    }
  },
  props: {
    provinceId: [String, Number],
    cityId: [String, Number],
    countyId: [String, Number],
    pointId: [String, Number],
    address: [String, Number],
    showPoint: Boolean,
    width: String,
  },
  created() {
    this.getProvinceData()
    if (this.provinceId) {
      this.handleProvinceChange(this.provinceId)
    }
    if (this.cityId) {
      this.handleCityChange(this.cityId)
    }
    if (this.countyId) {
      this.handleCountyChange(this.countyId)
    }
  },
  watch: {
    provinceId(newVal) {
      if (newVal) {
        this.handleProvinceChange(newVal)
      }
    },
    cityId(newVal) {
      if (newVal) {
        this.handleCityChange(newVal)
      }
    },
    countyId(newVal) {
      if (newVal) {
        this.handleCountyChange(newVal)
      }
    },
  },
  methods: {
    getProvinceData() {
      o('Province').get().then(({data}) => {
        this.Provinces = data
      })
    },
    /* 省份变更 */
    handleProvinceChange(Province) {
      if (Province) {
        o('City').filter(`Province/Id eq ${Province}`).get().then(({ data }) => {
          this.Citys = data
        })
      } else {
        this.Citys = []
      }
      this.$emit('update:provinceId', Province)
    },
    /* 城市变更 */
    handleCityChange(City) {
      if (City) {
        o('County').filter(`City/Id eq ${City}`).get().then(({ data }) => {
          this.Countys = data
        })
      } else {
        this.Countys = []
      }
      this.$emit('update:cityId', City)
    },
    /* 区县变更 */
    handleCountyChange(County) {
      if (this.showPoint && County) {
        this.handleSearchPoint()
      } else {
        this.Points = []
      }
      this.$emit('update:countyId', County)
    },
    /* 查询网点 */
    handleSearchPoint() {
      o('Partner').filter(`IsPointOfSale eq true and City/Id eq ${this.cityId}`).get()
      .then(({data}) => {
        this.Points = data
      })
    },
    handlePointChange(value) {
      this.$emit('update:pointId', value)
    },
    handleAddressChange(value) {
      this.$emit('update:address', value)
    },
  },
}
</script>

<style lang="less" scoped>
.float-left {
  float: left;
}
</style>



// WEBPACK FOOTER //
// Address.vue?348e3c68